import { Select, Text } from '@chakra-ui/react'

import { FormItem } from 'components'
import useUnregisterDefaultValueField from '../../hooks/useUnregisterDefaultValueField'
import { DefaultValueCommonProps } from '../../types/DefaultValueCommonProps'
import useSetDefaultValueOnNotArrayData from '../../hooks/useSetDefaultValueOnNotArrayData'

export default function DefaultValueSingleSelection({ formMethods, question }: DefaultValueCommonProps) {
  useUnregisterDefaultValueField({ formMethods })

  useSetDefaultValueOnNotArrayData({ formMethods, question })

  return (
    <FormItem label="Valor inicial">
      {question?.options && question?.options?.length > 0 ? (
        <Select {...formMethods.register('default_value')}>
          <option value="">Nenhum valor inicial</option>
          {question?.options?.map((option) => {
            return (
              <option key={option} value={option}>
                {option}
              </option>
            )
          })}
        </Select>
      ) : (
        <Text variant="noData">Nenhuma opção disponível</Text>
      )}
    </FormItem>
  )
}
